import { GET_MY } from '../../containers/App/constants';
import {
  REQUEST_ACTION,
  REQUEST_ACTIONS,
  SET_SCROLL_POSITION,
} from './constants';

export function fetchActions() {
  return {
    type: GET_MY,
    id: REQUEST_ACTIONS,
    work: REQUEST_ACTIONS,
    gate: REQUEST_ACTIONS,
    path: `actions`,
  };
}

export function fetchAction(actionId) {
  throw 'fetchAction not implemented server-side';
  return {
    type: GET_MY,
    id: REQUEST_ACTION,
    actionId,
    work: REQUEST_ACTION,
    gate: REQUEST_ACTION + actionId,
    path: `actions/${actionId}`,
  };
}

export function setScrollPosition(itemId) {
  return {
    type: SET_SCROLL_POSITION,
    position: itemId,
  }
}
